<template>
  <div v-if="citations.length" class="citations">
    <button
      type="button"
      class="citations-toggle"
      @click="expanded = !expanded"
      :aria-expanded="expanded"
    >
      <font-awesome-icon :icon="['fas', 'link']" class="citations-icon" />
      {{ citations.length }} source{{ citations.length === 1 ? '' : 's' }}
      <font-awesome-icon
        :icon="['fas', expanded ? 'caret-down' : 'caret-right']"
        class="citations-caret"
      />
    </button>
    <transition name="citations-expand">
      <ul v-if="expanded" class="citations-list">
        <li
          v-for="(citation, index) in citations"
          :key="citation.file_id || `${citation.filename}-${index}`"
          class="citation-chip"
          :style="{ animationDelay: `${index * 60}ms` }"
        >
          <span class="citation-filename" :title="citation.filename">{{ citation.filename }}</span>
          <span class="citation-score">{{ formatScore(citation.score) }}</span>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CitationChips',
  props: {
    citations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    formatScore(score) {
      if (score == null || Number.isNaN(Number(score))) {
        return '';
      }
      return `${Math.round(Number(score) * 100)}% match`;
    },
  },
};
</script>

<style scoped>
.citations {
  margin-top: 0.65rem;
}

.citations-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.55rem;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 0.7rem;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.citations-toggle:hover {
  background: var(--bg-tertiary);
  border-color: var(--border-color-light);
}

.citations-icon,
.citations-caret {
  font-size: 0.6rem;
}

.citations-list {
  list-style: none;
  margin: 0.5rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.citation-chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.45rem 0.65rem;
  border-radius: 0.5rem;
  border: 1px solid var(--border-color-light);
  background: var(--bg-secondary);
  font-size: 0.72rem;
  animation: citationFadeIn 0.35s ease both;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.citation-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px var(--shadow-color);
}

.citation-filename {
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.citation-score {
  color: #059669;
  font-weight: 600;
  white-space: nowrap;
}

.citations-expand-enter-active,
.citations-expand-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
  transform-origin: top;
}

.citations-expand-enter-from,
.citations-expand-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

@keyframes citationFadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
